import admission from "./assets/admission.png";
// import certificate from "./assets/certificate.png";
import desktop_2 from "./assets/desktop-2.png";
import iitb_building from "./assets/iitb_building.webp";
import "bootstrap/dist/js/bootstrap.min.js";
import { useState } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Col,
  Container,
  Image,
  ListGroup,
  Row,
} from "react-bootstrap";
import { Navigate, useParams } from "react-router-dom";
import { FaHouseChimney, FaRegCircleCheck } from "react-icons/fa6";
import { courses } from "Constants/courses";
import CourseInstructor from "Screens_old/CourseInstructor/CourseInstructor";
import "TrustEdge.css";
import trustEdgeStyles from "TrustEdge.module.css";
import FooterTrust from "Screens_old/Footer/FooterTrust";
import { classNames } from "Store/utils";
import { FaChevronDown } from "react-icons/fa6";
import { downloadBrochure } from "Utils/brochureUtils";
import BrochureNotAvailableModal from "Components/BrochureNotAvailableModal";


const CoursePage = () => {
  const { id } = useParams();
  const [activeKey, setActiveKey] = useState(null);
  const [showBrochureModal, setShowBrochureModal] = useState(false);
  const [modalCourseName, setModalCourseName] = useState('');
  const course = courses.find((course) => course.id === parseInt(id));

  if (!course) return <Navigate to={"/"} />;

  const courseIdToCheck = parseInt(id);

  const program = courses.find(
    (program) =>
      program.category === "Professional Certificate" &&
      program.subCourses.some(
        (subCourse) => subCourse.courseId === courseIdToCheck
      )
  );

  if (!program) return <Navigate to={"/"} />;

  const toggleIcon = (index) => (activeKey === index ? "-" : "+");

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);

  const handleShowBrochureModal = (courseName) => {
    setModalCourseName(courseName);
    setShowBrochureModal(true);
  };

  // Function to handle brochure download
  const handleDownloadBrochure = () => {
    downloadBrochure(course.id, course.program_title, handleShowBrochureModal);
  };

  return (
    <>
      <Container fluid className="px-0">
        {/* <NavigationBar /> */}
        <Container fluid style={{ backgroundColor: "rgb(235 241 255)" }}>
          <Container
            fluid
            className="d-flex h-100 align-items-center py-2"
            style={{
              maxWidth: "1600px",
            }}
          >
            <Breadcrumb className={classNames(trustEdgeStyles['size14'], "ps-2")}>
              <BreadcrumbItem href="/">
                <FaHouseChimney color={"rgb(54, 54, 54)"} />
              </BreadcrumbItem>
              {(course.category === "Individual Course - Ongoing" ||
                course.category === "Individual Course - Upcoming") && (
                  <BreadcrumbItem href="/#courses-we-offer"
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/#courses-we-offer";
                    }}>Courses</BreadcrumbItem>
                )}

              <BreadcrumbItem
                href={`/course/${id}`}
                className="text-decoration-none"
              >
                {course.program_title}
              </BreadcrumbItem>
            </Breadcrumb>
          </Container>
        </Container>
        <Container
          className="w-100"
          fluid
          style={{
            backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.4)), url(${desktop_2})`,
            backgroundSize: "cover",
            backgroundPosition: "top left, bottom right",
            backgroundRepeat: "no-repeat, no-repeat",
            backgroundBlendMode: "overlay",
          }}
        >
          <Container style={{ maxWidth: "1600px", minHeight: "60vh" }}>
            <Row className="pt-5 align-items-center">
              <Col xs={12} sm={12} md={6} lg={6} className="text-left mb-4 mb-md-0">
                <h1 className="top-heading mb-4">{course.program_title}</h1>
                <p className="trustedge_size18 lh-base mb-0">{course.description}</p>
                <Row className="mt-4">
                  <Col xs={12} sm={6} md={12} lg={6} className="mb-2 mb-sm-0">
                    <Button
                      className="apply-btn m-0 w-100"
                      as="a"
                      href="https://docs.google.com/forms/d/164dEI9sipU0u72BXJ9TX6CArQFCz5U9DrgEeosz4o3w/viewform?edit_requested=true"
                      target="_blank"
                      rel="noopener noreferrer"
                      disabled={!course.active}
                    >
                      Apply Now
                    </Button>
                  </Col>
                  <Col xs={12} sm={6} md={12} lg={6}>
                    <button
                      className={`download-btn m-0 w-100 user-select-none ${!course.active ? "disabled" : ""}`}
                      onClick={course.active && handleDownloadBrochure}
                      disabled={!course.active}
                    >
                      Download Brochure
                    </button>
                  </Col>

                </Row>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6}>
                <div className="video-background ms-lg-3 p-lg-3 rounded">
                  {/* <iframe
            width="100%"
            height="400"
            src="https://www.youtube.com/embed/VIDEO_ID"
            title="Advanced Executive Program in Cybersecurity"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ zIndex: 1 }}
          ></iframe> */}
                  <img
                    className="w-100"
                    style={{
                      borderRadius: "10px",
                      height: "auto",
                      maxHeight: "400px",
                      objectFit: "cover"
                    }}
                    src={iitb_building}
                    alt="IITB Building"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </Container>
        <Container fluid className="px-0" style={{ background: "#F4FBFF" }}>
          <Container className={classNames(trustEdgeStyles['container-width'], "py-4 py-md-5 d-flex justify-content-center")}>
            <div style={{ width: "80%" }}>
              {/* <Row className="p-3 justify-content-around">
              <Col
                xs={12}
                md={6}
                sm={12}
                className="p-3 d-flex flex-column align-items-start mx-lg-5 mb-3 shadow"
                style={{ width: "400px", height: "auto", background: "#EEEEEE" }}
              >
                <h5 className="mb-3 trustedge_size18">
                  {course.duration}, {course.credits}, {course.level} Level
                  {course.mode ? `, ${course.mode}` : ""}
                </h5>
                <div>
                  <strong className="trustedge_size18">Structure:</strong>
                  <ul className="trustedge_size18">
                    <li>1 - 1.5 hr videos per week</li>
                    <li>2.5 - 3 hr labs per week</li>
                    <li>Periodic 0.5 - 1 hr tutorials</li>
                  </ul>
                </div>
                <div className="trustedge_size18">
                  <strong>Expected time commitment:</strong> 6-8 hrs a week
                  <br />
                  Interactions will be conducted during evenings/weekends
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                sm={12}
                className="my-0 p-3 d-flex flex-column align-items-start mx-lg-5 mb-3 shadow"
                style={{ width: "400px", height: "auto", background: "#EEEEEE" }}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: course.course_details?.prerequisites,
                  }}
                />
              </Col>
            </Row> */}
              {/* Course Details and Duration Row */}
              <Row className="g-1 g-md-2 mb-2">
                <h4 className="text-center w-100 mb-3">
                  Course Details and Prerequisites
                </h4>
                <Col xs={12} md={6} className="px-2 px-md-3">
                  <div className="text-start">
                    <p className="trustedge_size22 trustedge_weight-700 mb-1">Course Details</p>
                    <h5 className="mb-2 trustedge_size18 text-gray">
                      {course.duration}
                      {course.mode ? `, ${course.mode}` : ""}
                    </h5>
                  </div>
                </Col>
                <Col xs={12} md={6} className="px-2 px-md-3">
                  <div className="text-start">
                    <p className="trustedge_size22 trustedge_weight-700 mb-1">Time Committment:</p>
                    {course?.total_time_commitment ? (<div className="trustedge_size18 text-gray mt-1">
                      {course?.total_time_commitment}
                      <br />
                    </div>) : (<div className="trustedge_size18 text-gray mt-1">
                      Expected time commitment: 8 hrs a week
                      <br />
                      Interactions will be conducted during evenings/weekends
                    </div>)}
                  </div>
                </Col>
              </Row>

              {/* Structure and Prerequisites Row */}
              <Row className="g-1 g-md-2 mb-2">
                <Col xs={12} md={6} className="px-2 px-md-3">
                  <div className="text-start">
                    <p className="trustedge_size22 trustedge_weight-700 mb-1">Structure:</p>
                    <ul className="trustedge_size18 text-gray">
                      <li>1 - 1.5 hr videos per week</li>
                      <li>2.5 - 3 hr labs per week</li>
                      <li>Periodic 0.5 - 1 hr tutorials</li>
                    </ul>
                  </div>
                </Col>
                <Col xs={12} md={6} className="px-2 px-md-3">
                  <div className="text-start">
                    <p className="trustedge_size22 trustedge_weight-700 mb-1">Pre-requisites:</p>
                    <div
                      className="trustedge_size18 text-gray"
                      dangerouslySetInnerHTML={{
                        __html: course.course_details?.prerequisites,
                      }}
                    />
                  </div>
                </Col>
              </Row>

              {/* Pre-Recorded Content and Weekly Labs Row */}
              {(course?.pre_recorded_content || course?.weekly_lab) && (
                <Row className="g-1 g-md-2 mb-2">
                  <Col xs={12} md={6} className="px-2 px-md-3">
                    {course?.pre_recorded_content && (
                      <div className="text-start">
                        <p className="trustedge_size22 trustedge_weight-700 mb-1">Pre-Recorded Video Content:</p>
                        <span className="trustedge_size18 text-gray">{course?.pre_recorded_content}</span>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} md={6} className="px-2 px-md-3">
                    {course?.weekly_lab && (
                      <div className="text-start">
                        <p className="trustedge_size22 trustedge_weight-700 mb-1">Weekly Labs:</p>
                        <span className="trustedge_size18 text-gray">{course?.weekly_lab}</span>
                      </div>
                    )}
                  </Col>
                </Row>
              )}
            </div>
          </Container>
        </Container>

        <Container fluid>
          <Container className={classNames(trustEdgeStyles['container-width'], "py-4 py-md-5")}>
            <Row className="justify-content-between">
              <Col
                className="pt-4 pb-2"
                xs={12}
                sm={12}
                md={8}
                style={{ height: "100%" }}
              >
                <h3>Course Content</h3>

                <div id="trustedge_accordion">
                  {course?.course_content?.modules?.map((module, index) => (
                    <div className="card border-0" key={index}>
                      {/* Clickable Full Row */}
                      <div
                        className="card-header d-flex justify-content-between align-items-center"
                        id={`heading${index}`}
                        data-toggle="collapse"
                        data-target={`#collapse${index}`}
                        aria-expanded={index === 0 ? "true" : "false"}
                        aria-controls={`collapse${index}`}
                        style={{
                          cursor: "pointer",
                          borderRadius: "5px",
                          padding: "15px",
                          backgroundColor: "white",
                          border: "1px solid #ddd",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        <span>{module.module_name}</span>
                        <span className="chevron-icon">
                          <FaChevronDown />
                        </span>
                      </div>

                      {/* Collapsible Content */}
                      <div
                        id={`collapse${index}`}
                        className={index === 0 ? "collapse show" : "collapse"}
                        aria-labelledby={`heading${index}`}
                        data-parent="#trustedge_accordion"
                      >
                        <div className="card-body">
                          <p dangerouslySetInnerHTML={{ __html: module?.module_description }} />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>

              <Col xs={12} sm={12} md={4} className="pt-4 pb-2">
                <h3 style={{ marginLeft: "8px" }}>Key Features</h3>
                <ListGroup variant="flush">
                  {course.key_features?.map((feature, index) => (
                    <ListGroup.Item key={index}>
                      <div className="d-flex my-1">
                        <FaRegCircleCheck
                          size={20}
                          className="text-primary"
                          style={{
                            flexShrink: 0,
                            marginTop: "2px",
                            marginRight: "4px",
                          }}
                        />
                        <p className="trustedge_size18">{feature}</p>
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </Col>
            </Row>
          </Container>
        </Container>

        <Container fluid className="px-0" style={{ background: "#ECF4FF" }}>
          <Container className={classNames(trustEdgeStyles['container-width'], "py-4 py-md-5")}>
            <Row>
              <Col lg={6}>
                {course.eligibility && (
                  <div className="p-2">
                    <h3 className="ps-1 py-1" style={{ background: "#ECF4FF" }}>
                      Eligibility
                    </h3>
                    <p className="trustedge_size20">
                      The eligibility criteria for the {course.program_title} is
                      as follows:
                    </p>
                    <div
                      dangerouslySetInnerHTML={{ __html: course.eligibility }}
                    />
                  </div>
                )}
              </Col>
              <Col lg={6}>
                {course.fees && (
                  <div className="p-2" style={{ lineHeight: "32px" }}>
                    <h3 className="ps-1 py-1" style={{ background: "#ECF4FF" }}>
                      Fees
                    </h3>
                    <p className="trustedge_size20">
                      Different categories have different fees (inclusive of
                      taxes) for this course
                    </p>
                    <div dangerouslySetInnerHTML={{ __html: course.fees }} />
                    <br />
                    <p className="trustedge_size18">
                      Bulk registrations from an organization in regular
                      category can avail further discounts. <br />
                      Please contact us at:
                      contactus-trustedge@cse.iiib.ac.in
                      {/* <img className="img-fluid" src={iitb_support_email} /> */}
                    </p>
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </Container >
        <Container fluid className="px-0">
          <Container className={classNames(trustEdgeStyles['container-width'], "py-4 py-md-5")}>
            <h2 className="text-center mb-4">Application Process</h2>
            {/* <p className="trustedge_size20 text-center">
              The application process consists of three simple steps. An offer of
              admission will be made to the selected candidates and accepted by
              the candidates by paying the admission fee.
            </p> */}
            <Row className="mt-4 d-flex">
              {/* <Col md={4} className="mb-4 d-flex">
                <div className="text-left shadow p-3 flex-fill">
                  <h3>STEP 1</h3>
                  <h4 className="mb-2">Submit Application</h4>
                  <p className="trustedge_size18">
                    Tell us about your background, interests. Also upload relevant
                    documents establishing the category you are applying for (ID
                    card, Transcripts/Qualifying degree/ Letter from
                    institute/employer). Extra but optional uploads include
                    statement of purpose and recommendation letters.
                  </p>
                </div>
              </Col>
              <Col md={4} className="mb-4 d-flex">
                <div className="text-left shadow p-3 flex-fill">
                  <h3>STEP 2</h3>
                  <h4 className="mb-2">Screening</h4>
                  <p className="trustedge_size18">
                    Given limited seats, candidates will be shortlisted based on
                    their application (Qualifications, transcripts, statement of
                    purpose, and recommendation letters if any).
                  </p>
                </div>
              </Col>
              <Col md={4} className="mb-4 d-flex">
                <div className="text-left shadow p-3 flex-fill">
                  <h3>STEP 3</h3>
                  <h4 className="mb-2">Admission</h4>
                  <p className="trustedge_size18">
                    Selected candidates will receive an offer letter to pay the
                    fees. Post payment, candidates will be enrolled in the
                    relevant course.
                  </p>
                </div>
              </Col> */}

              <Col md={6} className=" flex-column">
                <div className="text-left trends-border p-3 mb-4 flex-fill">
                  <h4 className="mb-2 trustedge_size18">
                    <div
                      className="text-center"
                      style={{
                        display: "inline-block",
                        background: "#7facfb",
                        width: "32px",
                        borderRadius: "10px",
                        color: "white",
                        marginRight: "4px",
                      }}
                    >
                      1
                    </div>{" "}
                    Submit Application
                  </h4>
                  <p className="trustedge_size18" style={{ paddingLeft: "38px" }}>
                    Tell us about your background, interests. Also upload
                    relevant documents establishing the category you are
                    applying for (ID card, Transcripts/Qualifying degree/ Letter
                    from institute/employer). Extra but optional uploads include
                    statement of purpose and recommendation letters.
                  </p>
                </div>
                <div className="text-left trends-border p-3 mb-4 flex-fill">
                  <h4 className="mb-2 trustedge_size18">
                    <div
                      className="text-center"
                      style={{
                        display: "inline-block",
                        background: "#7facfb",
                        width: "32px",
                        borderRadius: "10px",
                        color: "white",
                        marginRight: "4px",
                      }}
                    >
                      2
                    </div>{" "}
                    Screening
                  </h4>
                  <p className="trustedge_size18" style={{ paddingLeft: "38px" }}>
                    Given limited seats, candidates will be shortlisted based on
                    their application (Qualifications, transcripts, statement of
                    purpose, and recommendation letters if any).
                  </p>
                </div>
                <div className="text-left trends-border p-3 mb-4 flex-fill">
                  <h4 className="mb-2 trustedge_size18">
                    <div
                      className="text-center"
                      style={{
                        display: "inline-block",
                        background: "#7facfb",
                        width: "32px",
                        borderRadius: "10px",
                        color: "white",
                        marginRight: "4px",
                      }}
                    >
                      3
                    </div>{" "}
                    Admission
                  </h4>
                  <p className="trustedge_size18" style={{ paddingLeft: "38px" }}>
                    Selected candidates will receive an offer letter to pay the
                    fees. Post payment, candidates will be enrolled in the
                    relevant course.
                  </p>
                </div>
              </Col>

              {/* Right Column - Empty or for another purpose */}
              <Col xs={12} md={6} className="d-flex justify-content-center">
                <div className="position-relative" style={{ maxWidth: '90%' }}> {/* Limit image width on mobile */}
                  <Image className="img-fluid" src={admission} />

                  {/* Option 1: Modern Rounded Button (Recommended) */}
                  <div
                    className="position-absolute d-flex justify-content-center align-items-end w-100 h-100"
                    style={{ top: 0, left: 0, paddingBottom: '20px' }}
                  >
                    <Button
                      as="a"
                      href="https://docs.google.com/forms/d/164dEI9sipU0u72BXJ9TX6CArQFCz5U9DrgEeosz4o3w/viewform?edit_requested=true"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        background: 'linear-gradient(135deg, #5a6fd8 0%, #6b4190 100%)',
                        border: 'none',
                        borderRadius: '25px',
                        padding: '12px 28px',
                        fontSize: '16px',
                        fontWeight: '600',
                        color: 'white',
                        textDecoration: 'none',
                        boxShadow: '0 8px 20px rgba(90, 111, 216, 0.3)',
                        transition: 'all 0.3s ease',
                        transform: 'translateY(0)',
                        position: 'relative', /* Added for shine effect */
                        overflow: 'hidden', /* Added for shine effect */
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 12px 25px rgba(90, 111, 216, 0.4)';
                        /* Add shine effect */
                        e.target.style.background = 'linear-gradient(135deg, #6b7fe8 0%, #7b51a0 100%)';
                        e.target.style.boxShadow = '0 12px 25px rgba(90, 111, 216, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.3)';
                        /* Create animated shine sweep */
                        const shine = document.createElement('div');
                        shine.style.cssText = `
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
      animation: shine 0.6s ease-out;
      pointer-events: none;
    `;
                        e.target.appendChild(shine);
                        /* Add shine animation keyframes */
                        if (!document.getElementById('shine-keyframes')) {
                          const style = document.createElement('style');
                          style.id = 'shine-keyframes';
                          style.textContent = `
        @keyframes shine {
          0% { left: -100%; }
          100% { left: 100%; }
        }
      `;
                          document.head.appendChild(style);
                        }
                        /* Remove shine element after animation */
                        setTimeout(() => {
                          if (shine.parentNode) shine.parentNode.removeChild(shine);
                        }, 600);
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.background = 'linear-gradient(135deg, #5a6fd8 0%, #6b4190 100%)';
                        e.target.style.boxShadow = '0 8px 20px rgba(90, 111, 216, 0.3)';
                      }}
                    >
                      Apply Now
                    </Button>
                  </div>
                </div>
              </Col>

            </Row>
          </Container>
        </Container >
        <Container fluid className="px-0" style={{ background: "#ECF4FF" }}>
          <Container className={classNames(trustEdgeStyles['container-width'])}>
            <Row className="mt-3 d-flex justify-content-between">
              <Col
                lg={6}
                md={6}
                sm={12}
                xs={12}
                className="p-5 d-flex justify-content-center"
              >
                <div className="trustedge_size20 d-flex flex-column justify-content-center">
                  <h4>Evaluation & Certification</h4>

                  <div className="d-flex align-items-center mb-3">
                    <i className="fas fa-clipboard-list me-3" style={{ fontSize: '1.5rem', color: '#007bff' }}></i>
                    <div>
                      <strong>Proctored, in-person exams at IIT Bombay</strong>
                      <br />
                      <span className="text-muted">(75% weight)</span>
                    </div>
                  </div>

                  <div className="d-flex align-items-center mb-4">
                    <i className="fas fa-laptop me-3" style={{ fontSize: '1.5rem', color: '#007bff' }}></i>
                    <div>
                      <strong>Online assessments & assignments</strong>
                      <br />
                      <span className="text-muted">(25% weight)</span>
                    </div>
                  </div>

                  <p>
                    This course is eligible for an individual course certificate
                    as well as{" "}
                    <a
                      style={{ textDecoration: "none" }}
                      href={`/program/${program?.id}`}
                    >
                      {program.program_title}
                    </a>
                    .
                  </p>
                </div>
              </Col>
              <Col lg={6} md={6} sm={12} xs={12} className="py-lg-5 px-3">
                {course?.certificate ? (
                  <img src={course.certificate} className="my-2 img-fluid" alt="Course Certificate" />
                ) : (
                  <div
                    className="my-2 d-flex align-items-center justify-content-center text-center trends-border"
                    style={{
                      backgroundColor: '#ECF4FF',
                      borderRadius: '10px',
                      minHeight: '280px',
                      padding: '3rem 2rem'
                    }}
                  >
                    <div>
                      <div
                        className="mb-4"
                        style={{
                          width: '80px',
                          height: '80px',
                          backgroundColor: '#76E4FD',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto',
                          boxShadow: '0 4px 12px rgba(0, 123, 255, 0.2)'
                        }}
                      >
                        <svg
                          width="40"
                          height="40"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#007BFF"
                          strokeWidth="2"
                        >
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                          <polyline points="14,2 14,8 20,8"></polyline>
                          <line x1="16" y1="13" x2="8" y2="13"></line>
                          <line x1="16" y1="17" x2="8" y2="17"></line>
                        </svg>
                      </div>
                      <h4 className="mb-3 trustedge_size18" style={{ color: '#007BFF', fontWeight: '700' }}>
                        Certificate Coming Soon
                      </h4>
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </Container >
        {course?.instructors?.length > 0 ? (
          <Container
            fluid
            className="px-0 w-100"
            style={{
              backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.4)), url(${desktop_2})`,
              backgroundSize: "cover",
              backgroundPosition: "top left, bottom right",
              backgroundRepeat: "no-repeat, no-repeat",
              backgroundBlendMode: "overlay",
            }}
          >
            <Container
              className={classNames(trustEdgeStyles['container-width'])}
              style={{ minHeight: "30vh", padding: "24px 0" }}
            >
              <h2 className="text-center py-4">
                Meet your course faculty
              </h2>
              {course?.instructors?.map((instructor) => (
                <CourseInstructor
                  instructor_img={instructor.image}
                  instructor_name={instructor.name}
                  instructor_description={instructor.description}
                />
              ))}
            </Container>
          </Container >
        ) : (
          <></>
        )}
      </Container >
      {(id === "2" || id === "7") && <Container fluid className="px-3 d-flex justify-content-center">
        <h3 className="py-lg-5 py-3" style={{ fontSize: 'clamp(18px, 4vw, 24px)' }}>
          What are you waiting for? Know more about the <span
            style={{
              whiteSpace: "nowrap",
              color: "#338bd9",
              cursor: "pointer",
            }}
            onClick={() => {
              window.location.href = "/#courses-we-offer";
            }}
          >courses</span> and{" "}
          <span
            style={{
              whiteSpace: "nowrap",
              color: "#338bd9",
              cursor: "pointer",
            }}
            onClick={() => {
              // Link to Google Forms registration
              window.open('https://docs.google.com/forms/d/164dEI9sipU0u72BXJ9TX6CArQFCz5U9DrgEeosz4o3w/viewform?edit_requested=true', '_blank', 'noopener,noreferrer');
            }}
          >
            apply now.
          </span>
          {" "}Any questions, visit our <span
            style={{
              whiteSpace: "nowrap",
              color: "#338bd9",
              cursor: "pointer",
            }}
            onClick={() => {
              // Link to Google Forms registration
              window.open("https://docs.google.com/document/d/1kTVJY8_fhmI8pOzuYLL3Kq804DPN0mJNwokuiFq8OD8/edit?tab=t.0", '_blank', 'noopener,noreferrer');
            }}
          >
            FAQ
          </span>.
        </h3>
      </Container>}
      {/* {course?.reviews?.length > 0 && (
        <Container
          fluid
          className="py-3 py-md-5 user-select-none pb-3 pb-md-5"
          style={{ background: "#fafafa" }}
        >
          <Container className={classNames(trustEdgeStyles['container-width'], "px-2 px-md-4 mb-3 mb-md-5")}>
            <h2 className="py-3 py-md-5 px-2 px-md-4 text-center text-md-start fs-4 fs-md-2">
              See what our users say
            </h2>
            <div className="px-1 px-md-4 mb-3 mb-md-5">
              <ReviewSlider reviews={course?.reviews} />
            </div>
          </Container>
        </Container>
      )} */}
      <FooterTrust />
      <BrochureNotAvailableModal
        show={showBrochureModal}
        onHide={() => setShowBrochureModal(false)}
        courseName={modalCourseName}
      />
    </>
  );
};

export default CoursePage;
